import qs from "qs";
let envName = "";
let UA = navigator.userAgent.toLowerCase();
export const getEnvName = function() {
    if (envName) {
        return Promise.resolve(envName);
    } else {
        let { ma_id, ma_sign, unionid, openid } = qs.parse(
            location.search.slice(1)
        );
        // TODO：具体判断逻辑，设计为异步是因为hmsapp、小程序可能是异步判断
        if (UA.indexOf("hmsapp") > -1 || /source=APP/.test(location.href)) {
            return Promise.resolve("hmsapp");
        } else if (
            /source=SWTP/.test(location.href) ||
            (UA.match(/MicroMessenger/i) == "micromessenger" &&
                (/source=WX|source=MINI_PROGRAM/.test(location.href) ||
                    ma_id ||
                    ma_sign ||
                    unionid ||
                    openid))
        ) {
            return new Promise((resolve, reject) => {
                if (UA.indexOf("miniprogram") > -1) {
                    resolve("miniprogram");
                } else {
                    resolve("wx");
                }
            });
        } else {
            return Promise.resolve("h5");
        }
    }
};
